const animeModule = require('animejs');
const anime = animeModule.default || animeModule;
window.debugAnimeModule = animeModule;
window.debugAnime = anime;

$(function () {
  const allocations = [
    [
        {id: "fonds-euro", name: "Fonds Euro", value: 49},
        {id: "obligations-souveraines", name: "Obligations", value: 43},
        {id: "actions-us-canada", name: "Actions", value: 6},
        {id: "matieres-premieres", name: "Matières premières", value: 1},
        {id: "alternatif", name: "Alternatif", value: 1}
    ],
    [
        {id: "fonds-euro", name: "Fonds Euro", value: 44},
        {id: "obligations-souveraines", name: "Obligations", value: 40},
        {id: "actions-us-canada", name: "Actions", value: 12},
        {id: "matieres-premieres", name: "Matières premières", value: 2},
        {id: "alternatif", name: "Alternatif", value: 2}
    ],
    [
        {id: "fonds-euro", name: "Fonds Euro", value: 39},
        {id: "obligations-souveraines", name: "Obligations", value: 37},
        {id: "actions-us-canada", name: "Actions", value: 20},
        {id: "matieres-premieres", name: "Matières premières", value: 2},
        {id: "alternatif", name: "Alternatif", value: 2}
    ],
    [
        {id: "fonds-euro", name: "Fonds Euro", value: 34},
        {id: "obligations-souveraines", name: "Obligations", value: 34},
        {id: "actions-us-canada", name: "Actions", value: 28},
        {id: "matieres-premieres", name: "Matières premières", value: 2},
        {id: "alternatif", name: "Alternatif", value: 2}
    ],
    [
        {id: "fonds-euro", name: "Fonds Euro", value: 29},
        {id: "obligations-souveraines", name: "Obligations", value: 32},
        {id: "actions-us-canada", name: "Actions", value: 35},
        {id: "matieres-premieres", name: "Matières premières", value: 2},
        {id: "alternatif", name: "Alternatif", value: 2}
    ],
    [
        {id: "fonds-euro", name: "Fonds Euro", value: 24},
        {id: "obligations-souveraines", name: "Obligations", value: 30},
        {id: "actions-us-canada", name: "Actions", value: 42},
        {id: "matieres-premieres", name: "Matières premières", value: 2},
        {id: "alternatif", name: "Alternatif", value: 2}
    ],
    [
        {id: "fonds-euro", name: "Fonds Euro", value: 20},
        {id: "obligations-souveraines", name: "Obligations", value: 27},
        {id: "actions-us-canada", name: "Actions", value: 49},
        {id: "matieres-premieres", name: "Matières premières", value: 2},
        {id: "alternatif", name: "Alternatif", value: 2}
    ],
    [
        {id: "fonds-euro", name: "Fonds Euro", value: 16},
        {id: "obligations-souveraines", name: "Obligations", value: 24},
        {id: "actions-us-canada", name: "Actions", value: 56},
        {id: "matieres-premieres", name: "Matières premières", value: 2},
        {id: "alternatif", name: "Alternatif", value: 2}
    ],
    [
        {id: "fonds-euro", name: "Fonds Euro", value: 13},
        {id: "obligations-souveraines", name: "Obligations", value: 22},
        {id: "actions-us-canada", name: "Actions", value: 61},
        {id: "matieres-premieres", name: "Matières premières", value: 2},
        {id: "alternatif", name: "Alternatif", value: 2}
    ],
    [
        {id: "fonds-euro", name: "Fonds Euro", value: 4},
        {id: "obligations-souveraines", name: "Obligations", value: 15},
        {id: "actions-us-canada", name: "Actions", value: 73},
        {id: "matieres-premieres", name: "Matières premières", value: 4},
        {id: "alternatif", name: "Alternatif", value: 4}
    ]
  ]

  const $el = $('#bloc-risk-profile'),
      $window = $(window)

  // Risk profile change

  const $inputs = $('.planets__text__buttons input'),
      $planets = $('.planet-item')

  function set_planet_size (index, data, key){

      let mv = 0;
      for(let i = 0 ; i < data.length; i++) {
          if(key == data[i].id) {
              mv = data[i].value;
              break;
          }
      }

      const factor = $window.width() > 600 ? 3 : 2,
          value = 10 + (factor *  mv),
          $planet = $planets.eq(index)


      $planet.children().css({width: value+'px', height: value+'px'})
      value < 50 ? $planet.addClass('small') : $planet.removeClass('small')
  }

  function set_planets_sizes (index) {
      const data = allocations[index]
      set_planet_size(4, data, 'fonds-euro')
      set_planet_size(3, data, 'obligations-souveraines')
      set_planet_size(2, data, 'actions-us-canada')
      set_planet_size(1, data, 'matieres-premieres')
      set_planet_size(0, data, 'alternatif')
  }

  $inputs.on('change', function(e){
      e.preventDefault();
      const idx = $(this).val();
      set_planets_sizes(idx)
  })


  // Initialize
  set_planets_sizes(1)



  function animate_planet(index, duration) {
      if($(window).width() > 767) {
          const path = anime.path('#assets-system-orbit-' + index);

          return anime({
              targets: '#asset-system-planet-' + index,
              translateX: path('x'),
              translateY: path('y'),
              duration: duration,
              loop: true,
              easing: 'cubicBezier(0.33, 0.53, 0.61, 0.76)'
          });
      }
  }

  const animations = [
      animate_planet(1, 15000),
      animate_planet(2, 17000),
      animate_planet(3, 20000),
      animate_planet(4, 22000),
      animate_planet(5, 30000),
  ]

  // var resizeSolarWindow = function() {
  //     if($(window).width() < 767) {
  //         $(animations).each(function() {
  //             this.pause();
  //         })
  //     } else {
  //         $(animations).each(function() {
  //             this.play();
  //         })
  //     }
  // }

  // resizeSolarWindow();
})
